import React from "react";
import _ from "lodash";
import { t } from "../../../helpers/translator";
import CountDown from "../countdownHook";
import SmartTable from "../../../components/smartTable";
import SportTicket from "./sportTicket";
import CasinoTicket from "./casinoTicket";
import KeyboardInput from "../InputKeyboard";
import MultipleTicketsGoldenRace from "./goldenRace";

export default function multipleTicketsPopup() {
  const { tickets, earlyCashout } = this.props;
  const { errorMsg, expandedBarcode, ticketInBarcode } = this.state;
  const hasTicket = !_.isEmpty(tickets);

  const renderActiveRowContent = (item) => {
    if (item.betType === "BetBuilder")
      return (
        <div className="bet-builder-details">
          <div>{item.betBuilderDetails.teamNames}</div>
          {item.betBuilderDetails.descriptions.map((message) => (
            <div key={message}>{message}</div>
          ))}
        </div>
      );

    if (!item.casinoTicket)
      return (
        <SportTicket
          event={item.events}
          cashout={item.cashout_amount && !earlyCashout?.[item.barcode]}
          cashout_amount={item.cashout_amount}
          earlyCashoutBets={this.earlyCashoutBets}
          barcode={item.barcode}
        />
      );

    if (item.dataFromCasino.ProviderId === 54)
      return <MultipleTicketsGoldenRace dataFromCasino={item.dataFromCasino} />;

    if (item.casinoTicket && item.success)
      return <CasinoTicket dataFromSwarm={item.dataFromSwarm} dataFromCasino={item.dataFromCasino} />;

    return <div className="details-not-available">{t("Details not available now!")}</div>;
  };

  if (this.props.tickets && hasTicket) {
    const ticketsList = Object.values(tickets).sort((first, second) => second.scaned_at - first.scaned_at);
    const sportTickets = ticketsList.filter((item) => !item.cashout);
    const cashoutTickets = ticketsList.filter((item) => item.cashout);

    return (
      <>
        {!this.props.onlyList && (
          <div className="scan-tickets-top">
            {errorMsg && <p className="error-text container">{errorMsg}</p>}
            {!this.props.onlyList && (
              <>
                <button className="add-to-balance" onClick={this.addToBalance} disabled={this.addToBalanceDisabled}>
                  {t(`Add To Balance`)}
                </button>
                <div className="clock-place">
                  {t(`Dialog will automatically close after `)}
                  <span className="time-count">
                    {hasTicket ? (
                      <CountDown
                        propsSecond={this.state.countdown}
                        secondChange={this.timerSecondChange}
                        endOfWork={this.timerWorkEnd}
                      />
                    ) : null}
                  </span>
                  &nbsp;{t(`seconds`)}
                </div>
              </>
            )}

            <div className="tickets-right">
              <div className="scan-img-block">
                <i />
              </div>
              <div className="scan-tickets-text">
                <div className="use-barcode">
                  <KeyboardInput
                    numeric
                    type="text"
                    placeholder={t("Barcode number")}
                    value={ticketInBarcode}
                    onChange={this.barcodeNumberChange}
                  />
                  <button className="add-barcode" onClick={this.confirmBarcode}>
                    {t("Add")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="ticket-tables-wrapper">
          {!!sportTickets.length && (
            <SmartTable
              columnConfig={this.ticketsColumnConfig()}
              // eslint-disable-next-line react/jsx-no-bind
              activeRowOpen={(item) => expandedBarcode === item.barcode}
              // eslint-disable-next-line react/jsx-no-bind
              className="ticket-b-table"
              rowClick={(e, item) => this.setActiveClass(item.barcode)}
              data={sportTickets}
              // eslint-disable-next-line react/jsx-no-bind
              activeRowContent={renderActiveRowContent}
            />
          )}
          {!!cashoutTickets.length && (
            <SmartTable
              columnConfig={this.cashoutTicketsColumnConfig()}
              // eslint-disable-next-line react/jsx-no-bind
              activeRowOpen={(item) => expandedBarcode === item.barcode}
              // eslint-disable-next-line react/jsx-no-bind
              className="ticket-b-table ticket-b-table-cashout"
              rowClick={(e, item) => this.setActiveClass(item.barcode)}
              data={cashoutTickets}
              // eslint-disable-next-line react/jsx-no-bind
              activeRowContent={(item) =>
                !item.casinoTicket ? (
                  <SportTicket
                    event={item.events}
                    cashout_ticket
                    cashout={item.cashout_amount && !earlyCashout?.[item.barcode]}
                    cashout_amount={item.cashout_amount}
                    earlyCashoutBets={this.earlyCashoutBets}
                    barcode={item.barcode}
                  />
                ) : (
                  item.casinoTicket && (
                    <CasinoTicket dataFromSwarm={item.dataFromSwarm} dataFromCasino={item.dataFromCasino} />
                  )
                )
              }
            />
          )}
        </div>
      </>
    );
  } else {
    return (
      <div className="bar-code-start">
        <div className="scan-img-block">
          <i />
        </div>
        <div className="scan-tickets-text">
          {t(`Scan your tickets or use Barcode number`)}
          <div className="use-barcode">
            <KeyboardInput
              numeric
              type="text"
              placeholder={t("Barcode number")}
              value={ticketInBarcode}
              onChange={this.barcodeNumberChange}
            />
            <button className="add-barcode" onClick={this.confirmBarcode}>
              {t("Add")}
            </button>
          </div>
        </div>
        <p className="error-text">{errorMsg}</p>
      </div>
    );
  }
}
